var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-rating',{attrs:{"id":"ratingstar","name":"ratingStar","color":"#72ca4a"},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}),_vm._v(" "),_c('p',{staticClass:"mt-2"},[_vm._v("評分: "+_vm._s(_vm.value))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }